<portals-click-scan></portals-click-scan>
 <!-- <portals-leave-message></portals-leave-message> -->
  <!-- <portals-collect-email></portals-collect-email> -->